import { Card } from './card';

/**
 * Skeleton loader for card grid layouts (clients, manufacturers, vetters, users).
 */
export function CardSkeletons({ count = 6 }: { count?: number }) {
	return (
		<div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
			{Array.from({ length: count }).map((_, i) => (
				<Card key={i} className="border-line-1 bg-surface py-0">
					<div className="p-4">
						<div className="mb-3.5 flex items-start gap-3">
							<div className="h-11 w-11 animate-pulse rounded-[var(--r-2)] bg-surface-fill" />
							<div className="flex-1">
								<div className="mb-1.5 h-4 w-28 animate-pulse rounded bg-surface-fill" />
								<div className="h-3 w-20 animate-pulse rounded bg-surface-fill" />
							</div>
						</div>
						<div className="h-12 animate-pulse rounded bg-surface-fill" />
					</div>
				</Card>
			))}
		</div>
	);
}

/**
 * Skeleton loader for table/list layouts.
 */
export function TableSkeleton({ rows = 6 }: { rows?: number }) {
	return (
		<Card className="overflow-hidden border-line-1 bg-surface">
			{Array.from({ length: rows }).map((_, i) => (
				<div
					key={i}
					className="flex items-center gap-4 px-4 py-3.5"
					style={{
						borderBottom: i < rows - 1 ? '0.5px solid var(--line-1)' : 'none',
					}}
				>
					<div className="h-8 w-8 animate-pulse rounded-[var(--r-2)] bg-surface-fill" />
					<div className="h-4 w-32 animate-pulse rounded bg-surface-fill" />
					<div className="h-3 w-40 animate-pulse rounded bg-surface-fill" />
					<div className="ml-auto h-5 w-16 animate-pulse rounded bg-surface-fill" />
				</div>
			))}
		</Card>
	);
}

/**
 * Skeleton loader for detail pages (two-column layout).
 */
export function DetailSkeleton() {
	return (
		<div className="mx-auto max-w-[var(--content-max)] px-4 pt-6 pb-20 sm:px-6 md:px-8">
			<div className="mb-5 h-4 w-16 animate-pulse rounded bg-surface-fill" />
			<div className="mb-7 flex items-start gap-4">
				<div className="flex-1">
					<div className="mb-2 h-7 w-48 animate-pulse rounded bg-surface-fill" />
					<div className="h-4 w-72 animate-pulse rounded bg-surface-fill" />
				</div>
			</div>
			<div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr]">
				{Array.from({ length: 4 }).map((_, i) => (
					<div
						key={i}
						className="h-[160px] animate-pulse rounded-[var(--r-3)] border border-line-1 bg-surface"
					/>
				))}
			</div>
		</div>
	);
}
